package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.EditW500Rounded: ImageVector
    get() {
        if (_editW500Rounded != null) {
            return _editW500Rounded!!
        }
        _editW500Rounded = Builder(name = "EditW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(202.63f, 757.13f)
                horizontalLineToRelative(57.24f)
                lineToRelative(374.74f, -374.74f)
                lineToRelative(-56.76f, -57.0f)
                lineToRelative(-375.22f, 375.22f)
                verticalLineToRelative(56.52f)
                close()
                moveTo(157.37f, 848.13f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                verticalLineToRelative(-102.26f)
                quadToRelative(0.0f, -18.15f, 6.84f, -34.69f)
                quadToRelative(6.83f, -16.53f, 19.51f, -29.2f)
                lineToRelative(501.17f, -500.41f)
                quadToRelative(12.48f, -11.72f, 27.7f, -17.96f)
                quadToRelative(15.21f, -6.24f, 31.93f, -6.24f)
                quadToRelative(16.48f, 0.0f, 32.2f, 6.24f)
                quadToRelative(15.71f, 6.24f, 27.67f, 18.72f)
                lineToRelative(65.28f, 65.56f)
                quadToRelative(12.48f, 11.72f, 18.34f, 27.56f)
                quadToRelative(5.86f, 15.83f, 5.86f, 31.79f)
                quadToRelative(0.0f, 16.72f, -5.86f, 32.05f)
                quadToRelative(-5.86f, 15.34f, -18.34f, 27.82f)
                lineTo(324.0f, 821.78f)
                quadToRelative(-12.67f, 12.68f, -29.21f, 19.51f)
                quadToRelative(-16.53f, 6.84f, -34.68f, 6.84f)
                lineTo(157.37f, 848.13f)
                close()
                moveTo(754.74f, 261.74f)
                lineTo(698.5f, 205.26f)
                lineTo(754.74f, 261.74f)
                close()
                moveTo(605.85f, 354.15f)
                lineTo(577.85f, 325.39f)
                lineTo(634.61f, 382.39f)
                lineTo(605.85f, 354.15f)
                close()
            }
        }
        .build()
        return _editW500Rounded!!
    }

private var _editW500Rounded: ImageVector? = null
